module.exports = __webpack_public_path__ + "media/images/icons/ticket-venue-e1016b60bae87f03b6ac1e974309ce0f.svg";